<template>
  <div class="plans">
    <h1>成绩</h1>
    <div class="content">
      <div class="result">
        <div style="width: 100%; text-align: center">
          <h1>我的成绩</h1>
        </div>
        <div
          v-if="showScoreDetail == 1"
          style="text-align: center; margin-bottom: 5px"
        >
          <span style="color: #ff0000">*点击课程名或分数查看详情</span>
        </div>
        <div v-if="gradeData">
          <table
            v-if="$store.state.homeObj.credit_bank_show != '1'"
            class="MsoTableGrid"
          >
            <tr>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">姓名</p>
              </td>
              <td style="border: solid windowtext 1pt">
                <p class="text">
                  {{ userInfo.name }}
                </p>
              </td>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">性别</p>
              </td>
              <td
                width="84"
                colspan="2"
                valign="top"
                style="border: solid windowtext 1pt"
              >
                <p class="text">
                  {{ ["", "男", "女"][userInfo.sex] }}
                </p>
              </td>
              <td style="border: solid windowtext 1pt">
                <p class="text">专业</p>
              </td>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">
                  {{ userInfo.proName }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">层次</p>
              </td>
              <td class="out">
                <p class="text">
                  {{ userInfo.learnLevel }}
                </p>
              </td>
              <td colspan="2" class="out">
                <p class="text">学制</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ userInfo.proSystem }}
                </p>
              </td>
              <td class="out">
                <p class="text">学号</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ userInfo.studentNo }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">身份证号</p>
              </td>
              <td colspan="5" class="out">
                <p class="text">
                  {{ userInfo.idNo }}
                </p>
              </td>
              <td class="out">
                <p class="text">入学日期</p>
              </td>
              <td colspan="2" class="out">
                <p v-if="userInfo.inSchoolDate" class="text">
                  {{ common.formatTimeDate(userInfo.inSchoolDate) }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="10" class="out">
                <p class="text">学 习 成 绩</p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">学期</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">课程类型</p>
              </td>
              <td colspan="4" class="out">
                <p class="text">课程</p>
              </td>
              <td class="out">
                <p class="text">成绩</p>
              </td>
              <td class="out" v-if="$store.state.homeObj.course_mode == '3'">
                <p class="text">学分</p>
              </td>
            </tr>
            <tr v-for="item in gradeData" :key="item.id">
              <td colspan="2" class="out">
                <p class="text">
                  {{ item.layoutTermOrder }}
                </p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ item.courseType }}
                </p>
              </td>
              <td colspan="4" class="out">
                <p class="text">
                  <span
                    :class="
                      item.showColor === 2 ? 'simulation-b' : 'simulation-a'
                    "
                    @click="
                      gotoDetail(
                        item.id,
                        item.viewName,
                        item.scoreStr,
                        item.updateTime,
                        item.isEdit
                      )
                    "
                  >
                    <span v-if="item && item.isEdit === 1" style="color: blue">
                      {{ item.viewName }}
                      <span
                        v-if="item.isChargeName == '补'"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >补</span
                      >
                    </span>
                    <span v-if="item && item.isEdit === 0">
                      {{ item.viewName }}
                      <span
                        v-if="item.isChargeName == '补'"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >补</span
                      >
                    </span>
                  </span>
                </p>
              </td>
              <td class="out">
                <p class="text">
                  <span
                    :class="
                      item.showColor === 2 ? 'simulation-b' : 'simulation-a'
                    "
                    @click="
                      gotoDetail(
                        item.id,
                        item.viewName,
                        item.scoreStr,
                        item.updateTime,
                        item.isEdit
                      )
                    "
                  >
                    <span
                      v-if="item && item.isEdit === 1"
                      :style="item.showColor === 0 ? 'red' : 'blue'"
                    >
                      {{ item.scoreStr }}
                    </span>
                    <span v-if="item && item.isEdit === 0">
                      {{ item.scoreStr }}
                    </span>
                  </span>
                </p>
              </td>
              <td class="out" v-if="$store.state.homeObj.course_mode == '3'">
                <p class="text">{{ item.planLessonPeriod }}</p>
              </td>
            </tr>
          </table>
          <table
            v-if="$store.state.homeObj.credit_bank_show == '1'"
            class="MsoTableGrid"
          >
            <tr>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">姓名</p>
              </td>
              <td style="border: solid windowtext 1pt">
                <p class="text">
                  {{ userInfo.name }}
                </p>
              </td>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">性别</p>
              </td>
              <td
                width="84"
                valign="top"
                colspan="2"
                style="border: solid windowtext 1pt"
              >
                <p class="text">
                  {{ ["", "男", "女"][userInfo.sex] }}
                </p>
              </td>
              <td style="border: solid windowtext 1pt">
                <p class="text">专业</p>
              </td>
              <td colspan="2" style="border: solid windowtext 1pt">
                <p class="text">
                  {{ userInfo.proName }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">层次</p>
              </td>
              <td class="out">
                <p class="text">
                  {{ userInfo.learnLevel }}
                </p>
              </td>
              <td colspan="2" class="out">
                <p class="text">学制</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ userInfo.proSystem }}
                </p>
              </td>
              <td class="out">
                <p class="text">学号</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ userInfo.studentNo }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">身份证号</p>
              </td>
              <td colspan="5" class="out">
                <p class="text">
                  {{ userInfo.idNo }}
                </p>
              </td>
              <td class="out">
                <p class="text">入学日期</p>
              </td>
              <td colspan="2" class="out">
                <p v-if="userInfo.inSchoolDate" class="text">
                  {{ common.formatTimeDate(userInfo.inSchoolDate) }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="10" class="out">
                <p class="text">学 习 成 绩</p>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="out">
                <p class="text">学期</p>
              </td>
              <td colspan="2" class="out">
                <p class="text">课程类型</p>
              </td>
              <td colspan="4" class="out">
                <p class="text">课程</p>
              </td>
              <td class="out">
                <p class="text">成绩</p>
              </td>
              <td class="out">
                <p class="text">学分</p>
              </td>
            </tr>
            <tr v-for="item in gradeData" :key="item.id">
              <td colspan="2" class="out">
                <p class="text">
                  {{ item.layoutTermOrder }}
                </p>
              </td>
              <td colspan="2" class="out">
                <p class="text">
                  {{ item.courseType }}
                </p>
              </td>
              <td colspan="4" class="out">
                <p class="text">
                  <span
                    :class="
                      item.showColor === 2 ? 'simulation-b' : 'simulation-a'
                    "
                    @click="
                      gotoDetail(
                        item.id,
                        item.viewName,
                        item.scoreStr,
                        item.updateTime,
                        item.isEdit
                      )
                    "
                  >
                    <span v-if="item && item.isEdit === 1" style="color: blue">
                      {{ item.viewName }}
                      <span
                        v-if="item.isChargeName == '补'"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >补</span
                      >
                    </span>
                    <span v-if="item && item.isEdit === 0">
                      {{ item.viewName }}
                      <span
                        v-if="item.isChargeName == '补'"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >补</span
                      >
                    </span>
                  </span>
                </p>
              </td>
              <td class="out">
                <p class="text">
                  <span
                    :class="
                      item.showColor === 2 ? 'simulation-b' : 'simulation-a'
                    "
                    @click="
                      gotoDetail(
                        item.id,
                        item.viewName,
                        item.scoreStr,
                        item.updateTime,
                        item.isEdit
                      )
                    "
                  >
                    <span
                      v-if="item && item.isEdit === 1"
                      :style="item.showColor === 0 ? 'red' : 'blue'"
                    >
                      {{ item.scoreStr }}
                    </span>
                    <span v-if="item && item.isEdit === 0">
                      {{ item.scoreStr }}
                    </span>
                  </span>
                </p>
              </td>

              <td class="out">
                <p class="text">
                  <span lang="EN-US">
                    <span
                      v-if="item && item.isEdit === 1"
                      :style="item.showColor === 0 ? 'red' : 'blue'"
                    >
                      {{ item.lessonPeriod }}
                      <span
                        v-if="item.isCharge == 1"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >兑</span
                      >
                    </span>
                    <span v-if="item && item.isEdit === 0">
                      {{ item.lessonPeriod }}
                      <span
                        v-if="item.isCharge == 1"
                        :style="{
                          color: '#ff0000',
                          fontSize: '12px',
                        }"
                        >兑</span
                      >
                    </span>
                  </span>
                </p>
              </td>
            </tr>
          </table>
          <table
            v-if="$store.state.homeObj.course_mode == '3'"
            class="MsoTableGrid"
          >
            <tr>
              <td colspan="10" class="out">
                <p class="text">学 分 汇 总</p>
              </td>
            </tr>
            <tr>
              <td class="out" colspan="2">
                <p class="text">课程类型</p>
              </td>
              <td class="out">
                <p class="text">应修学分</p>
              </td>
              <td class="out">
                <p class="text">可选学分</p>
              </td>
              <td class="out">
                <p class="text">已修得学分</p>
              </td>
              <td class="out">
                <p class="text">是否修满学分</p>
              </td>
            </tr>
            <tr v-for="(category, index) in courseData" :key="index">
              <td
                class="out"
                :rowspan="
                  practicalCourse ? courseData.length + 1 : courseData.length
                "
                v-if="index == 0"
              >
                <p class="text">必修课</p>
              </td>
              <td class="out">
                <p class="text">{{ category.courseType }}</p>
              </td>
              <td class="out" v-if="index == 0" :rowspan="courseData.length">
                <p class="text">{{ compulsoryScore }}</p>
              </td>
              <td class="out">
                <p class="text">{{ category.waitLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ category.ssLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ category.isSuccess }}</p>
              </td>
            </tr>
            <tr v-if="practicalCourse">
              <td class="out">
                <p class="text">{{ practicalCourse.courseType }}</p>
              </td>
              <td class="out">
                <p class="text">{{ practicalCourse.epLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ practicalCourse.waitLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ practicalCourse.ssLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ practicalCourse.isSuccess }}</p>
              </td>
            </tr>
            <tr v-if="electiveCourse">
              <td class="out" colspan="2">
                <p class="text">{{ electiveCourse.courseType }}</p>
              </td>
              <td class="out">
                <p class="text">{{ electiveCourse.epLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ electiveCourse.waitLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ electiveCourse.ssLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ electiveCourse.isSuccess }}</p>
              </td>
            </tr>
            <tr>
              <td class="out" colspan="2">
                <p class="text">总计</p>
              </td>
              <td class="out">
                <p class="text">{{ total.epLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ total.waitLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ total.ssLessonPeriod }}</p>
              </td>
              <td class="out">
                <p class="text">{{ total.isSuccess }}</p>
              </td>
            </tr>
          </table>
          <div
            style="
              width: 82%;
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              font-size: 13px;
              color: #3b3b3b;
            "
          >
            <span v-if="tips" class="high-light-red">{{ tips || "" }}</span>
            <span v-else></span>
            <span>查询日期：{{ common.formatTime(time) }}</span>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :title="title"
      :visible="detailShowFlag"
      @cancel="handleCancel"
      :footer="null"
      :width="1000"
    >
      <grade-info
        :currentDetail="currentDetail"
        :currentScore="currentScore"
        :currentUpdateTime="currentUpdateTime"
        :isEdit="isEdit"
        :scoreId="scoreId"
        @freshScore="getfreshScore"
        @getDeatilAllValue="getDeatilAllValue"
      />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import gradeInfo from "./gradeInfo";
import { simpleDebounce } from "./simpleDebounce.js";
export default {
  name: "PlanList",
  components: { gradeInfo },
  props: {
    gradeData: Array,
    time: Number,
  },
  data: function () {
    return {
      detailShowFlag: false,
      currentDetail: null,
      title: "成绩详情",
      currentScore: "",
      currentUpdateTime: null,
      scoreId: "",
      isEdit: 0,
      tips: "",
      showScoreDetail: 1,
      courseData: [],
      electiveCourse: undefined,
      practicalCourse: undefined,
      total: {
        epLessonPeriod: 0,
        waitLessonPeriod: 0,
        ssLessonPeriod: 0,
        isSuccess: undefined,
      },
      compulsoryScore: 0,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    //判断字符串 是数字转换成数值类型 否则数据类型不变
    convertStringToNumber(str) {
      let num = Number(str);
      if (!isNaN(num)) {
        return num;
      } else {
        return str;
      }
    },

    getDeatilAllValue: simpleDebounce(function (id, show) {
      this.axios
        .get(`/biz/score/info`, {
          params: { score_id: id, token: this.common.getStorage("token") },
        })
        .then((res) => {
          let data = res.result;
          let gradeData = {};
          data.forEach((item, index) => {
            if (item.pid && item.pid !== "0") {
              // 判断该项是否是子项
              // 是子项，将其加入到childList
              if (!gradeData[item.pid]) {
                gradeData[item.pid] = {};
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              } else {
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              }
            } else if (item.pid === "0") {
              // 非子项，将其放入parent属性
              if (!gradeData[item.id]) {
                gradeData[item.id] = {};
                gradeData[item.id].parent = item;
              } else {
                gradeData[item.id].parent = item;
              }
            }
          });
          this.currentDetail = gradeData;
        });
      this.axios.get("/biz/score/mine").then((res) => {
        if (res.success) {
          if (res.result) {
            // console.log('已进入')
            res.result.forEach((res) => {
              // console.log(item,'item')
              if (res.id === id) {
                this.currentScore = this.convertStringToNumber(res.scoreStr);
                this.$message.success("刷新成功!");
              }
            });
          }
        }
      });
    }, 500),

    gotoDetail(id, name, score, updateTime, isEdit) {
      if (this.showScoreDetail == 1) {
        this.title = `《${name}》成绩详情`;
        this.currentScore = this.convertStringToNumber(score);
        this.currentUpdateTime = updateTime;
        this.isEdit = isEdit;
        this.scoreId = id;
        this.getDetail(id, true);
      }
    },
    handleCancel() {
      this.detailShowFlag = false;
      if (this.detailShowFlag === false) {
        this.$emit("get", 1);
      }
    },
    getfreshScore(msg) {
      setTimeout(() => {
        this.getDetail(msg.scoreId, msg.isShow);
      }, 500);
    },
    getDetail(id, isShow) {
      // console.log('getDetail')
      this.axios
        .get(`/biz/score/info`, {
          params: { score_id: id, token: this.common.getStorage("token") },
        })
        .then((res) => {
          let data = res.result;
          let gradeData = {};
          data.forEach((item, index) => {
            if (item.pid && item.pid !== "0") {
              // 判断该项是否是子项
              // 是子项，将其加入到childList
              if (!gradeData[item.pid]) {
                gradeData[item.pid] = {};
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              } else {
                if (gradeData[item.pid].childList) {
                  gradeData[item.pid].childList.push(item);
                } else {
                  gradeData[item.pid].childList = [];
                  gradeData[item.pid].childList.push(item);
                }
              }
            } else if (item.pid === "0") {
              // 非子项，将其放入parent属性
              if (!gradeData[item.id]) {
                gradeData[item.id] = {};
                gradeData[item.id].parent = item;
              } else {
                gradeData[item.id].parent = item;
              }
            }
          });
          this.currentDetail = gradeData;
          this.detailShowFlag = isShow;
        });
    },

    getTips() {
      this.axios
        .get("/biz/score/infoDesc", { params: { score_id: "" } })
        .then((res) => {
          if (res.success) {
            if (res.result) {
              this.tips = res.result;
            }
          }
        });
    },
    async getPeriodSummary() {
      let res = await this.axios.get("/biz/score/lessonPeriodSummary");
      const { result } = res;
      let isSuccess = "已修满";
      result.map((res) => {
        if (res.courseType === "选修课") {
          this.electiveCourse = res;
        } else if (res.courseType === "实践课") {
          this.practicalCourse = res;
        } else {
          this.courseData.push(res);
          this.compulsoryScore += res.epLessonPeriod;
        }
        this.total.epLessonPeriod += res.epLessonPeriod;
        this.total.waitLessonPeriod += res.waitLessonPeriod;
        this.total.ssLessonPeriod += res.ssLessonPeriod;
        if (res.isSuccess === "未修满") {
          isSuccess = "未修满";
        }
      });
      this.total.isSuccess = isSuccess;
    },
  },
  mounted() {
    this.showScoreDetail = this.$store.state.homeObj.show_score_detail;
    this.getTips();
    this.getPeriodSummary();
  },
};
</script>

<style lang="scss" scoped>
.flex-table {
  border: 2px solid #8a8a8a;
  min-height: 200px;
}

.MsoTableGrid {
  color: rgb(59, 59, 59);
  width: 100%;
  border-collapse: collapse;
  border: none;
  mso-border-alt: solid windowtext 1pt;
  mso-yfti-tbllook: 1184;
  mso-padding-alt: 0cm 5.4pt 0cm 5.4pt;
  mso-border-insideh: 1pt solid windowtext;
  mso-border-insidev: 1pt solid windowtext;
}

.simulation-a {
  cursor: pointer;

  &:hover {
    color: #1890ff;
    text-decoration: underline;
  }
}

.simulation-b {
  cursor: pointer;

  &:hover {
    color: red;
    text-decoration: underline;
  }
}
</style>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  margin-bottom: 30px;

  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .content {
    background: #fff;
    padding: 28px;

    .infobg {
      background: $bgcontent;
    }

    .table {
      margin-bottom: 0px;

      .titles {
        font-weight: bold;
        text-align: left;
      }

      td {
        text-align: center;
      }

      .scores {
        text-decoration: underline;
        color: $bgColor;
        cursor: pointer;
      }
    }
  }
}

.detail {
  color: $bgColor;
  cursor: pointer;
}

.titles {
  background: $bgcontent;
}

.total {
  margin-top: 20px;
}

.scores1 {
  font-weight: bold;
  color: $bgColor;
}

.table td.titles {
  vertical-align: middle;
}

.deadline {
  color: #f00;
}

.score {
  color: #f00;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  margin-right: 5px;
}

button:focus {
  outline: 0px !important;
}

.table-head {
  &.table th, &.table td {
    padding: 0;
    vertical-align: middle;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    text-align: center;
    line-height: 32px;
  }
}

.result {
  width: 900px;
  margin: 0 auto;

  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .tableheader {
    strong {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-right: 20px;
    }

    span {
      margin-right: 20px;
    }
  }
}
.high-light-red {
  margin-left: 62px;
  color: #ff0000;
}
</style>
<style>
.out {
  border: solid windowtext 1pt;
  border-top: none;
}
.text {
  text-align: center;
  font-family: "微软雅黑 Light", sans-serif;
  line-height: 200%;
}
</style>



// WEBPACK FOOTER //
// src/pages/myscore/components/PlanList.vue